export enum FbsCustomerType {
  SingleMeterCustomer = "singleMeterCustomer",
  MultiMeterCustomer = "multiMeterCustomer",
  NonBioOrderCustomer = "nonBioOrderCustomer",
  BioOrderCustomer = "bioOrderCustomer",
  AutogasCustomer = "autogasCustomer",
  UnknownCustomer = "unknownCustomer",
}
